import { render } from "./FlexibleContent.vue?vue&type=template&id=0c3ff47c&scoped=true"
import script from "./FlexibleContent.vue?vue&type=script&lang=js"
export * from "./FlexibleContent.vue?vue&type=script&lang=js"

import "./FlexibleContent.vue?vue&type=style&index=0&id=0c3ff47c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c3ff47c"

export default script